import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AnimationOptions, RangedAnimationOptions } from "./AnimationOptions";
import { Random } from "./Random";
import { isBoolean } from "../../Utils/Utils";
import { setRangeValue } from "../../Utils/NumberUtils";
export var ValueWithRandom = /*#__PURE__*/function () {
  function ValueWithRandom() {
    _classCallCheck(this, ValueWithRandom);

    this.random = new Random();
    this.value = 0;
  }

  _createClass(ValueWithRandom, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (isBoolean(data.random)) {
        this.random.enable = data.random;
      } else {
        this.random.load(data.random);
      }

      if (data.value !== undefined) {
        this.value = setRangeValue(data.value, this.random.enable ? this.random.minimumValue : undefined);
      }
    }
  }]);

  return ValueWithRandom;
}();
export var AnimationValueWithRandom = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(AnimationValueWithRandom, _ValueWithRandom);

  var _super = _createSuper(AnimationValueWithRandom);

  function AnimationValueWithRandom() {
    var _this;

    _classCallCheck(this, AnimationValueWithRandom);

    _this = _super.call(this);
    _this.animation = new AnimationOptions();
    return _this;
  }

  _createClass(AnimationValueWithRandom, [{
    key: "anim",
    get: function get() {
      return this.animation;
    },
    set: function set(value) {
      this.animation = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _data$animation;

      _get(_getPrototypeOf(AnimationValueWithRandom.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      var animation = (_data$animation = data.animation) !== null && _data$animation !== void 0 ? _data$animation : data.anim;

      if (animation !== undefined) {
        this.animation.load(animation);
      }
    }
  }]);

  return AnimationValueWithRandom;
}(ValueWithRandom);
export var RangedAnimationValueWithRandom = /*#__PURE__*/function (_AnimationValueWithRa) {
  _inherits(RangedAnimationValueWithRandom, _AnimationValueWithRa);

  var _super2 = _createSuper(RangedAnimationValueWithRandom);

  function RangedAnimationValueWithRandom() {
    var _this2;

    _classCallCheck(this, RangedAnimationValueWithRandom);

    _this2 = _super2.call(this);
    _this2.animation = new RangedAnimationOptions();
    return _this2;
  }

  _createClass(RangedAnimationValueWithRandom, [{
    key: "load",
    value: function load(data) {
      var _data$animation2;

      _get(_getPrototypeOf(RangedAnimationValueWithRandom.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      var animation = (_data$animation2 = data.animation) !== null && _data$animation2 !== void 0 ? _data$animation2 : data.anim;

      if (animation !== undefined) {
        this.value = setRangeValue(this.value, this.animation.enable ? this.animation.minimumValue : undefined);
      }
    }
  }]);

  return RangedAnimationValueWithRandom;
}(AnimationValueWithRandom);